import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import SeverityFlag2 from '~/components/SeverityFlag2';
import * as artifactActions from '~/artifact/actions';
import StringService from '~/utils/StringService';
import Helpers from '~/utils/Helpers';
import ArtifactHelper from '~/utils/ArtifactHelper';
type ArtifactViewSummaryBarProps = {
  actions: object;
  artifact: object;
  baseUrl: string;
  components: any[];
};
class ArtifactViewSummaryBar extends React.Component<ArtifactViewSummaryBarProps, {}> {
  render() {
    const { artifact = {} } = this.props;
    const {
      vulnerabilityTypes = [],
      aliases = [],
      title = '',
      srcclrCvssVector,
      srcclrCvssScore,
      nvdCvssVector,
      nvdCvssScore,
      nvdCvss3Vector,
      nvdCvss3Score,
      srcclrCvss3Vector,
      srcclrCvss3Score,
      cveDigits,
      cveYear,
      cveStatus = '',
      overview,
      artifactComponents: components = [],
    } = artifact;
    const cvss2Score = Helpers.getFirstNonNull([nvdCvssScore, srcclrCvssScore]);
    const cvss2Vector = Helpers.getFirstNonNull([nvdCvssVector, srcclrCvssVector]);
    const cvss3Score = Helpers.getFirstNonNull([nvdCvss3Score, srcclrCvss3Score]);
    const cvss3Vector = Helpers.getFirstNonNull([nvdCvss3Vector, srcclrCvss3Vector]);
    const componentLinks = components.map((component, index) => {
      const {
        componentId: id,
        componentName: name = '',
        componentCoordinateType: coordinateType = '',
      } = component;
      const languageType = ArtifactHelper.getLanguageByCoordType(coordinateType);
      const componentLink = StringService.createSEOComponentItemUrl(
        name,
        languageType,
        id,
        coordinateType
      );
      const maybeCommaSeparator =
        components.length > 2 && index < components.length - 1 ? ', ' : ' and ';
      const separator = index === 0 ? '' : maybeCommaSeparator;
      return (
        <span key={`${id}-${index}`}>
          {separator}
          <Link className="link--primary" to={componentLink}>
            <strong>{name}</strong>
          </Link>
        </span>
      );
    });
    //TODO: Link vuln types to upcoming Landing Pages
    const types = vulnerabilityTypes.map((type, index) => {
      const separator = index === 0 ? '' : ', ';
      return (
        <span key={`${type}-${index}`}>
          {separator}

          <strong>{type}</strong>
        </span>
      );
    });

    const aliasValues = aliases.map((alias, index) => {
      const separator = index === 0 ? '' : ', ';
      return (
        <span key={`${alias}-${index}`}>
          {separator}
          <strong>{alias}</strong>
        </span>
      );
    });

    let cveElement = null;
    if (+cveDigits && +cveYear) {
      cveElement = (
        <span>
          <a
            className="inline-block link--primary"
            target="_blank"
            href={`https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-${artifact.cveYear}-${
              artifact.cveDigits
            }`}
          >
            CVE-{artifact.cveYear}-{artifact.cveDigits}{' '}
            <i className="fa fa-external-link font--12" />
          </a>
          {cveStatus === 'RESERVED' && <span className="font--12 block">{cveStatus}</span>}
        </span>
      );
    } else {
      cveElement = <span>SourceClear Premium (No CVE)</span>;
    }
    return (
      <div className="">
        <div className="grid grid--middle grid--full flex flex--align-items--flex-start bg-color--black-light bo-rad--bottom-5">
          <div className="grid__item col-1-4 ph pv color--white">
            <div className="grid">
              <div className="grid__item col-1-1 text--left">
                <SeverityFlag2 isCvss3={false} cvssScore={cvss2Score} cvssVector={cvss2Vector} />
                <div className="pt-">
                  <SeverityFlag2 isCvss3={true} cvssScore={cvss3Score} cvssVector={cvss3Vector} />
                </div>
                <div className="mt-">
                  <div
                    className="font--14"
                    data-automation-id="ArtifactViewSummaryBar-VulnerabilityCVELink"
                  >
                    <strong>{cveElement}</strong>
                  </div>
                  <div className="font--12 mt---">Disclosure</div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid__item col-3-4 ph pt lh+ bg-color--white-light bo-rb--1 border-color--white-dark min-height--225">
            <div className="pb">
              {componentLinks} {components.length > 1 ? 'are' : 'is'} vulnerable to{' '}
              <strong>{title}</strong>.<p className="word-wrap-text pt-">{overview}</p>
            </div>
            {vulnerabilityTypes.length > 0 && (
              <div className="bo-t--2 pv border-color--muted-light color--black-light">
                Tag{vulnerabilityTypes.length > 1 ? 's' : ''}: {types}
              </div>
            )}
            { (aliases.length > 0) && (
              <div className="bo-t--2 pv border-color--muted-light color--black-light">
                Aliases: {aliasValues}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    myState: state.myState,
    routing: state.routing,
    orgState: state.orgState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewSummaryBar);
